interface MergeLeafArgs {
  newPrimaryHours: number | undefined;
  newPrimaryRate: number | undefined;
  newPrimaryAmount: number | undefined;
  currentHours: number;
  currentRate: number;
  hoursAutoDerived: boolean;
  rateAutoDerived: boolean;
}

interface MergeLeafResult {
  hours: number;
  effectiveRate: number;
  total: number;
}

/**
 * Reconciles one leaf row (member / project / time-off) during a smart refresh.
 *
 * Auto-derived fields follow the latest server primary; manually-edited fields
 * are preserved. Total uses the server's `amount` only when both inputs are
 * auto-derived — otherwise we recompute it from the resulting hours × rate so
 * a partial manual edit doesn't show an inconsistent total.
 */
export const mergeLeafWithFormEdits = ({
  newPrimaryHours,
  newPrimaryRate,
  newPrimaryAmount,
  currentHours,
  currentRate,
  hoursAutoDerived,
  rateAutoDerived,
}: MergeLeafArgs): MergeLeafResult => {
  const hours = hoursAutoDerived ? (newPrimaryHours ?? 0) : currentHours;
  const effectiveRate = rateAutoDerived ? (newPrimaryRate ?? 0) : currentRate;
  const total =
    hoursAutoDerived && rateAutoDerived ? (newPrimaryAmount ?? 0) : hours * effectiveRate;

  return { hours, effectiveRate, total };
};
